function factory({ window, document, thn }) {
    const engine = {};
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            thn.domReady().then(function () {
                const language = document.documentElement.lang;
                if (language && ctx.langs.test(language)) {
                    resolve(language);
                    return;
                }
                resolve('en');
            });
        });
    };
    engine.isUserLogged = function isUserLogged(ctx) {
        const isLogged = !!document.querySelector('.js-userInfo');
        return isLogged;
    };
    return engine;
}

export { factory };
